const CaseSearchBar = ({
  searchQuery,
  setSearchQuery,
  onAddCase,
  toggleDeleteMode,
  isDeleteModeActive,
  isMobile,
  viewMode,
  toggleViewMode,
}) => {
  return (
    <div
      className={
        isMobile
          ? "flex items-center gap-2 mb-4"
          : "flex justify-between items-center mb-4 gap-2"
      }
    >
      <input
        type="text"
        placeholder="Search cases..."
        className={isMobile ? "flex-1 text-sm" : ""}
        style={{
          padding: isMobile ? "8px 12px" : "9px 14px",
          backgroundColor: "#F8FAFC",
          border: "1px solid #E2E8F0",
          borderRadius: "8px",
          color: "#0F172A",
          fontSize: "14px",
          outline: "none",
          width: isMobile ? undefined : "280px",
          transition: "border-color 0.2s",
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = "#30A69C";
          e.currentTarget.style.boxShadow = "0 0 0 2px rgba(48,166,156,0.2)";
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = "#E2E8F0";
          e.currentTarget.style.boxShadow = "none";
        }}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <div className="flex items-center gap-2 shrink-0">
        {!isMobile && (
          <button
            onClick={toggleViewMode}
            className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
            style={{
              backgroundColor: "#F1F5F9",
              border: "1px solid #E2E8F0",
              color: "#475569",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#E2E8F0";
              e.currentTarget.style.color = "#0F172A";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#F1F5F9";
              e.currentTarget.style.color = "#475569";
            }}
          >
            {viewMode === "cards" ? "List View" : "Card View"}
          </button>
        )}

        <button
          onClick={onAddCase}
          className={`${isMobile ? "px-3 py-2 text-sm" : "px-4 py-2"} rounded-lg font-medium transition-all duration-200`}
          style={{
            backgroundColor: "rgba(48,166,156,0.15)",
            border: "1px solid rgba(48,166,156,0.3)",
            color: "#30A69C",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(48,166,156,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(48,166,156,0.15)";
          }}
        >
          Add Case
        </button>

        <button
          onClick={toggleDeleteMode}
          className={`${isMobile ? "px-3 py-2 text-sm" : "px-4 py-2"} rounded-lg font-medium transition-all duration-200`}
          style={{
            backgroundColor: isDeleteModeActive
              ? "rgba(239,68,68,0.1)"
              : "#F1F5F9",
            border: isDeleteModeActive
              ? "1px solid rgba(239,68,68,0.3)"
              : "1px solid #E2E8F0",
            color: isDeleteModeActive ? "#EF4444" : "#475569",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = isDeleteModeActive
              ? "rgba(239,68,68,0.2)"
              : "#E2E8F0";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = isDeleteModeActive
              ? "rgba(239,68,68,0.1)"
              : "#F1F5F9";
          }}
        >
          {isDeleteModeActive ? "Cancel" : "Delete"}
        </button>
      </div>
    </div>
  );
};

export default CaseSearchBar;
